





















































































































import { Component, Vue } from "vue-property-decorator";
import CardListPasienGizi from "@/components/gizi/CardListPasienGizi.vue";
import TanggalGizi from "@/components/gizi/TanggalGizi.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import OrderGiziSvc from "@/services/OrderGizi";
import PasienNew from "@/services/PasienNew";
import { storeDokter } from "@/store/modules/dokter";
import { localISODate } from "@/utils/localDate";
import { bukaPemeriksaanGizi, bukaRiwayatPasien, formatUmur } from "@/utils/gizi";
import { PasienTagByRm } from "@/types/daftarPasienPenunjang";
import {
  DaftarPasienOrderGiziFilter,
  PasienGiziRow,
  PasienOrderGiziRow,
  PetugasRingkas,
  RentangTanggal
} from "@/types/orderGizi";

function filterAwal(): DaftarPasienOrderGiziFilter {
  return {
    tanggal: localISODate(),
    unit: [],
    dokter: null,
    petugas_gizi: null,
    tgl_masuk_start: null,
    tgl_masuk_end: null,
    q: ""
  };
}

@Component({
  components: { CardListPasienGizi, TanggalGizi, UnitRuangPicker }
})
export default class OrderGiziDaftarPasienPage extends Vue {
  filter: DaftarPasienOrderGiziFilter = filterAwal();
  tglMasuk: RentangTanggal | null = null;
  filterTermuat: DaftarPasienOrderGiziFilter | null = null;
  data: PasienOrderGiziRow[] = [];
  opsiPetugas: PetugasRingkas[] = [];
  pasienTagByRm: PasienTagByRm = {};
  memuat = false;
  tokenMuat = 0;

  get listDokter() {
    return storeDokter.listAll;
  }

  get baris(): PasienGiziRow[] {
    return this.data.map(row => ({
      row_key: row.row_key,
      register_id: row.register_id,
      rm: row.pasien.rm,
      nama: row.pasien.nama,
      sex: row.pasien.sex,
      umur: formatUmur(row.pasien.umur),
      unit_id: row.register_unit_id,
      unit_nama: row.unit.nama,
      episode_ranap: true,
      dokter_nama: row.dokter.nama,
      tanggal: row.tgl_masuk,
      ruang: row.ruang,
      diit: row.diit,
      keterangan: row.keterangan,
      shift_label: row.shift_label,
      shifts: row.shifts,
      petugas_gizi: row.petugas_gizi
    }));
  }

  get filterAktif(): DaftarPasienOrderGiziFilter {
    return {
      tanggal: this.filter.tanggal,
      unit: [...(this.filter.unit || [])],
      dokter: this.filter.dokter || null,
      petugas_gizi: this.filter.petugas_gizi || null,
      tgl_masuk_start: this.tglMasuk ? this.tglMasuk.start : null,
      tgl_masuk_end: this.tglMasuk ? this.tglMasuk.end : null,
      q: (this.filter.q || "").trim()
    };
  }

  get filterBerubah(): boolean {
    return (
      !!this.filterTermuat &&
      JSON.stringify(this.filterAktif) !== JSON.stringify(this.filterTermuat)
    );
  }

  mounted() {
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
    this.tampilkan();
  }

  tampilkan() {
    this.muat(this.filterAktif);
  }

  muatUlang() {
    this.muat(this.filterTermuat || this.filterAktif);
  }

  async muat(filter: DaftarPasienOrderGiziFilter) {
    if (!filter.tanggal) return;

    const token = ++this.tokenMuat;
    this.memuat = true;
    try {
      const res = await OrderGiziSvc.daftarPasien(filter);
      if (token !== this.tokenMuat) return;

      this.filterTermuat = filter;
      this.data = res.data || [];
      this.opsiPetugas = res.opsi ? res.opsi.petugas_gizi : [];
      this.muatTag(token);
    } catch {
      return;
    } finally {
      if (token === this.tokenMuat) {
        this.memuat = false;
      }
    }
  }

  muatTag(token: number) {
    const rms = Array.from(new Set(this.data.map(row => row.pasien.rm).filter(rm => !!rm)));

    if (!rms.length) {
      this.pasienTagByRm = {};
      return;
    }

    PasienNew.getMultiPasienTag(rms)
      .then((resp: PasienTagByRm) => {
        if (token !== this.tokenMuat) return;
        this.pasienTagByRm = resp && !Array.isArray(resp) ? resp : {};
      })
      .catch(() => undefined);
  }

  reset() {
    this.tglMasuk = null;
    this.filter = filterAwal();
    this.tampilkan();
  }

  bukaPemantauan(row: PasienGiziRow) {
    bukaPemeriksaanGizi(
      this.$router,
      { register_id: row.register_id, rm: row.rm, unit_id: row.unit_id },
      true
    );
  }

  bukaRiwayat(row: PasienGiziRow) {
    bukaRiwayatPasien(this.$router, row.rm);
  }
}
